// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1qLGH","hand":"Spinner_hand__2sm3O","rotate":"Spinner_rotate__1mQl5","invisible":"Spinner_invisible__1Di-Y"};